import React, { Component } from "react";
import { fire, auth } from "../../firebase/index";
import withAuthorization from "../../components/Authorization/withAuthorization";
import NoDataFound from "../Errors/NoDataFound";
import Loading from "../../components/Loading/Loading";
import _ from "lodash";
import LockGroupProfile from "./LockGroupProfile";
import LockGroupLocksButton from "./LockGroupLocksButton";
import LockGroupDetailsButton from "./LockGroupDetailsButton";
import { style } from "variables/Variables.jsx";
import { confirmAlert } from "react-confirm-alert";
import NotificationSystem from "react-notification-system";
import { Modal, ControlLabel, FormControl, Button } from "react-bootstrap";
import {
  BootstrapTable,
  TableHeaderColumn,
  SearchField,
  SizePerPageDropDown,
} from "react-bootstrap-table";
import TimeStamp from "react-timestamp";
import Multiselect from "react-widgets/lib/Multiselect";
import CreateGroupGuide from "../Tutorial/CreateGroupGuide";

// Css
import "../../assets/css/groupmanagement.css";

import LocalizedStrings from "react-localization";
import { customLog } from "../../variables/Variables";
import { FormGroup } from "semantic-ui-react";

let localizationStrings = new LocalizedStrings({
  en: {
    descriptionTitle: "Create and edit your lock group here",
    createGroupBtn: "Create Lock Group",
    deleteGroupBtn: "Delete Lock Group",
    removeSelected: "Remove Selected",
    groupNameHeader: "Lock Group Name",
    groupLocksHeader: "Lock Group Locks",
    createdAtHeader: "Created On",
    groupInfoHeader: "Info",
    groupEditHeader: "Edit",
    resultTitle1: "Showing ",
    resultTitle2: " to ",
    resultTitle3: " of ",
    resultTitle4: " Results",
    groupNamePlaceholder: "Enter Lock Group Name",
    groupDescriptionHeader: "Lock Group Description (optional)",
    groupDescriptionPlaceholder: "Enter Lock Group Description",
    addMembersHeader: "Select Locks",
    removeMemberBtn: "Remove Locks",
    nameHeader: "Lock Name",
    emailHeader: "Lock Serial No",
    emailHeader1: "Lock Model",
    selectedMembersHeader: "Lock Group List",
    confirmRemoveTitle: "Confirm Remove",
    removeGroupTitle: "Remove Lock group?",
    confirmTitle: "Confirm",
    cancelTitle: "Cancel",
    deleteSelectedSummary: "You are about to remove",
    deleteSelectedGroups: "selected lock groups",
    andMoreGroups: "and",
    moreGroupsSuffix: "more selected lock groups.",
    groupDetailsLocks: "locks",
    createTitle: "Create",
    noDataTitle: "There is no data to display",
    createGroupGuide: "Group Management",
    searchPlaceholder: "Search",
    deleteSuccessAlert: "Lock group successfully deleted",
    deleteFailAlert: "Failed to delete lock group",
    emptyFormAlert:
      "Please enter a lock group name and select at least 2 locks for the lock group",
    enterNameAlert: "Please enter a lock group name",
    minimumLockAlert:
      "Please ensure that you have selected at least 2 locks to be added into the lock group",
    unableCreateAlert: "Unable to create lock group, please try again",
    nameExistsAlert: "Lock group name already exists",
    createSuccessAlert: "Lock group successfully created",
    createFailAlert: "Failed to create lock group",
    loading: "Loading...",
  },
  ja: {
    descriptionTitle: "グループ編集",
    createGroupBtn: "グルーピング",
    deleteGroupBtn: "グループ削除",
    removeSelected: "削除",
    groupNameHeader: "グループ名",
    groupLocksHeader: "登録スマートロック",
    createdAtHeader: "作成日",
    groupInfoHeader: "お知らせ",
    groupEditHeader: "編集",
    resultTitle1: "表示 ",
    resultTitle2: " へ",
    resultTitle3: " の ",
    resultTitle4: " 結果",
    groupNamePlaceholder: "グループ名入力",
    groupDescriptionHeader: "グループメモ（オプション）",
    groupDescriptionPlaceholder: "グループメモ入力",
    addMembersHeader: "メンバー選択",
    removeMemberBtn: "ロックを削除",
    nameHeader: "名前",
    emailHeader: "Eメール",
    emailHeader1: "",
    selectedMembersHeader: "グループメンバーリスト",
    confirmRemoveTitle: "登録削除",
    removeGroupTitle: "グループを削除しますか？",
    confirmTitle: "OK",
    cancelTitle: "キャンセル",
    deleteSelectedSummary: "削除対象",
    deleteSelectedGroups: "件のロックグループです",
    andMoreGroups: "他",
    moreGroupsSuffix: "件のロックグループがあります。",
    groupDetailsLocks: "ロック",
    createTitle: "登録",
    noDataTitle: "表示するデータがありません。",
    createGroupGuide: "グループ管理",
    searchPlaceholder: "検索",
    deleteSuccessAlert: "ロックグループが正常に削除されました",
    deleteFailAlert: "ロックグループの削除に失敗しました",
    emptyFormAlert:
      "ロック グループ名を入力し、ロック グループとして少なくとも 2 つのロックを選択してください",
    enterNameAlert: "ロックグループ名を入力してください",
    minimumLockAlert:
      "ロック グループに追加するロックを少なくとも 2 つ選択していることを確認してください",
    unableCreateAlert:
      "ロック グループを作成できません、もう一度お試しください",
    nameExistsAlert: "ロックグループ名はすでに存在します",
    createSuccessAlert: "ロックグループが正常に作成されました",
    createFailAlert: "ロックグループの作成に失敗しました",
    loading: "読み込み中...",
  },
  es: {
    descriptionTitle: "Crea y edita tu grupo de candados aquí",
    createGroupBtn: "Crear Grupo de Candados",
    deleteGroupBtn: "Eliminar Grupo de Candados",
    removeSelected: "Eliminar Seleccion",
    groupNameHeader: "Nombre del Grupo de Candados",
    groupLocksHeader: "Candados del Grupo de Candados",
    createdAtHeader: "Creado el",
    groupInfoHeader: "Información",
    groupEditHeader: "Editar",
    resultTitle1: "Mostrando ",
    resultTitle2: " a ",
    resultTitle3: " de ",
    resultTitle4: " Resultados",
    groupNamePlaceholder: "Ingresa el Nombre del Grupo de Candados",
    groupDescriptionHeader: "Descripción del Grupo de Candados (opcional)",
    groupDescriptionPlaceholder: "Ingresa la Descripción del Grupo de Candados",
    addMembersHeader: "Seleccionar Candados",
    removeMemberBtn: "Eliminar Candados",
    nameHeader: "Nombre de la Candado",
    emailHeader: "Número de Serie de la Candado",
    emailHeader1: "Modelo de la Candado",
    selectedMembersHeader: "Lista del Grupo de Candados",
    confirmRemoveTitle: "Confirmar Eliminación",
    removeGroupTitle: "¿Eliminar el grupo de candados?",
    confirmTitle: "Confirmar",
    cancelTitle: "Cancelar",
    deleteSelectedSummary: "Estás a punto de eliminar",
    deleteSelectedGroups: "grupos de candados seleccionados",
    andMoreGroups: "y",
    moreGroupsSuffix: "grupos de candados seleccionados más.",
    groupDetailsLocks: "candados",
    createTitle: "Crear",
    noDataTitle: "No hay datos para mostrar",
    createGroupGuide: "Gestión de Grupos",
    searchPlaceholder: "Buscar",
    deleteSuccessAlert: "Grupo de candados eliminado exitosamente",
    deleteFailAlert: "No se pudo eliminar el grupo de candados",
    emptyFormAlert:
      "Ingrese un nombre de grupo de candado y seleccione al menos 2 candados para el grupo de candados",
    enterNameAlert: "Por favor ingresa un nombre de grupo de candados",
    minimumLockAlert:
      "Asegúrese de haber seleccionado al menos 2 candados para agregarlos al grupo de candados",
    unableCreateAlert:
      "No se puede crear el grupo de candados, inténtelo de nuevo",
    nameExistsAlert: "El nombre del grupo de candados ya existe",
    createSuccessAlert: "Grupo de candados creado exitosamente",
    createFailAlert: "No se pudo crear el grupo de candados",
    loading: "Cargando...",
  },
});

const buildGroupDeletePreview = (dropRowKeys = [], groups = []) => {
  const selectedGroups = groups.filter((group) =>
    dropRowKeys.includes(group.index),
  );

  const total = selectedGroups.length;

  if (total === 0) {
    return localizationStrings.removeGroupTitle;
  }

  const groupLines = selectedGroups.slice(0, 5).map((group, index) => {
    const name = group.name || "-";
    const lockCount = group.locks ? Object.keys(group.locks).length : 0;

    return `${index + 1}. ${name} — ${lockCount} ${
      localizationStrings.groupDetailsLocks
    }`;
  });

  if (total > 5) {
    return (
      <div>
        <p>
          {localizationStrings.deleteSelectedSummary} <strong>{total}</strong>{" "}
          {localizationStrings.deleteSelectedGroups}.
        </p>
        <div style={{ marginTop: "10px", marginBottom: "10px" }}>
          {groupLines.map((line, index) => (
            <div key={index}>{line}</div>
          ))}
          <div style={{ marginTop: "8px", fontStyle: "italic" }}>
            {localizationStrings.andMoreGroups} {total - 5}{" "}
            {localizationStrings.moreGroupsSuffix}
          </div>
        </div>
        <p>{localizationStrings.removeGroupTitle}</p>
      </div>
    );
  }

  return (
    <div>
      <p>
        {localizationStrings.deleteSelectedSummary} <strong>{total}</strong>{" "}
        {localizationStrings.deleteSelectedGroups}.
      </p>
      <div style={{ marginTop: "10px", marginBottom: "10px" }}>
        {groupLines.map((line, index) => (
          <div key={index}>{line}</div>
        ))}
      </div>
      <p>{localizationStrings.removeGroupTitle}</p>
    </div>
  );
};

const confirmRemove = (next, dropRowKeys, selectedRows) => {
  confirmAlert({
    title: `${localizationStrings.confirmRemoveTitle} (${dropRowKeys.length})`,
    message: buildGroupDeletePreview(dropRowKeys, selectedRows || []),
    buttons: [
      {
        label: localizationStrings.confirmTitle,
        onClick: () => next(),
      },
      {
        label: localizationStrings.cancelTitle,
        onClick: () => false,
      },
    ],
  });
};

class LockGroupManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      _notificationSystem: null,
      showPopup: false,
      groupName: "",
      groupNameExist: false,
      groupDesc: "",
      memberemaillistArray: [],
      selectedMember: [],
      selectedMemberValue: [],
      groupsArrayList: [],
      isSuperAdmin: false,
      isAdmin: false,
      superAdminID: "",
      loading: true,
      showPopupHelp: false,
      popupTitle: "",
      popupImage: [],
      locklistarray: [],
      lockgrouparray: [],
      selectedlockgroup: [],
      name: "",
      lockGroupDescription: "",
      lockGroupNameExist: false,
      createGroupLoading: false,
      selectedLockGroups: [],
    };

    this.handleCreateGroupPopupOpen = this.handleCreateGroupPopupOpen.bind(
      this,
    );
    this.handleCreateGroupPopupClose = this.handleCreateGroupPopupClose.bind(
      this,
    );
    this.renderSelectMember = this.renderSelectMember.bind(this);
    this.unselectMember = this.unselectMember.bind(this);
    this.showNotification = this.showNotification.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.insertGroupData = this.insertGroupData.bind(this);
    this.handleGroupNameChange = this.handleGroupNameChange.bind(this);
    this.handleGroupDescChange = this.handleGroupDescChange.bind(this);
    this.convertTimeStamp = this.convertTimeStamp.bind(this);
    this.createCustomSearchFieldForm = this.createCustomSearchFieldForm.bind(
      this,
    );
    this.createCustomSelectAllButton = this.createCustomSelectAllButton.bind(
      this,
    );
    this.createCustomSearchField = this.createCustomSearchField.bind(this);
    this.createCustomDeleteButton = this.createCustomDeleteButton.bind(this);
    this.createCustomInsertButton = this.createCustomInsertButton.bind(this);
    this.onAfterDeleteRow = this.onAfterDeleteRow.bind(this);
    this.renderGroupProfile = this.renderGroupProfile.bind(this);
    this.renderLockDetailsBtn = this.renderLockDetailsBtn.bind(this);
    this.renderGroupDetailsBtn = this.renderGroupDetailsBtn.bind(this);
  }

  componentWillMount() {
    //! LANGUAGE SETTING
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }

    fire
      .database()
      .ref("groupAccounts")
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          snapshot.forEach((superAdmin) => {
            const superAdminData = superAdmin.val();

            const memberDetails = superAdminData.members;

            for (let eachMemberId in memberDetails) {
              const eachMemberDetails = memberDetails[eachMemberId];
              const eachMemberEmail = eachMemberDetails.memberEmail;

              if (eachMemberEmail === auth.currentUser.email) {
                const superAdminID = superAdmin.key;
                this.setState({
                  isAdmin: eachMemberDetails.isAdmin,
                  isSuperAdmin: eachMemberDetails.isSuperAdmin,
                  superAdminID: superAdminID,
                });

                fire
                  .database()
                  .ref("lockGroupManagement") //change
                  .child(superAdminID)
                  .child(auth.currentUser.uid)
                  .once("value")
                  .then((snapshot) => {
                    var tempArray = [];
                    snapshot.forEach(function(childSnap) {
                      var dataWithKey = {
                        id: childSnap.key,
                        ...childSnap.val(),
                      };
                      tempArray.push(dataWithKey);
                    });

                    this.setState({
                      lockgrouparray: tempArray,
                      // loading: false,
                    });
                  });
              }
            }
          });
        }
      });

    fire
      .database()
      .ref("userLocks")
      .child(auth.currentUser.uid)
      .orderByKey()
      .once("value")
      .then((snapshot) => {
        const tempArray = this.snapshotToArray(snapshot);
        this.setState({
          // loading: false,
          locklistarray: tempArray,
        });
      });

    setTimeout(() => {
      this.setState({ loading: false });
    }, [2000]);
  }

  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  createCustomInsertButton() {
    return (
      <button
        className="createGroupBtn"
        onClick={this.handleCreateGroupPopupOpen}
      >
        <i className="fa fa-plus" /> {localizationStrings.createGroupBtn}
      </button>
    );
  }

  createCustomDeleteButton = (onBtnClick) => {
    return (
      <button className="deleteGroupBtn" onClick={onBtnClick}>
        <i className="far fa-trash-alt" /> {localizationStrings.removeSelected}
      </button>
    );
  };

  snapshotToArray = (snapshot) => {
    var returnArr = [];
    snapshot.forEach(function(childSnapshot) {
      var item = childSnapshot.val();
      item.key = childSnapshot.key;
      returnArr.push(item);
    });
    return returnArr;
  };
  retrieveChanges = (data) => {
    this.setState({
      lockgrouparray: data,
      loading: false,
    });
  };

  handleCreateGroupPopupOpen() {
    this.setState({
      showPopup: true,
    });
  }

  handleCreateGroupPopupClose() {
    fire
      .database()
      .ref("userLocks")
      .child(auth.currentUser.uid)
      .orderByKey()
      .once("value")
      .then((snapshot) => {
        var tempArray = [];
        tempArray = this.snapshotToArray(snapshot);

        this.setState({
          locklistarray: tempArray,
          selectedlockgroup: [],
          name: "",
          lockGroupDescription: "",
          showPopup: false,
        });
      });
  }

  renderSelectMember(cell, row) {
    return (
      <div>
        <button
          className={"select-btn"}
          onClick={(e) => {
            e.preventDefault();

            const lockListArrayList = this.state.locklistarray;
            const selectedLockGroupList = this.state.selectedlockgroup;

            lockListArrayList.splice(lockListArrayList.indexOf(row), 1);
            selectedLockGroupList.push(row);

            this.setState({
              locklistarray: lockListArrayList,
              selectedlockgroup: selectedLockGroupList,
            });
          }}
        >
          <span className="plusIcon">&#43;</span>
        </button>
      </div>
    );
  }

  unselectMember(cell, row) {
    return (
      <div>
        <button
          className={"unselect-btn"}
          onClick={(e) => {
            e.preventDefault();

            const lockListArrayList = this.state.locklistarray;
            const selectedLockGroupList = this.state.selectedlockgroup;

            lockListArrayList.push(row);
            selectedLockGroupList.splice(selectedLockGroupList.indexOf(row), 1);

            this.setState({
              locklistarray: lockListArrayList,
              selectedlockgroup: selectedLockGroupList,
            });
          }}
        >
          <span className="crossIcon">&times;</span>
        </button>
      </div>
    );
  }

  showNotification = (msg, lvl, position, duration) => {
    // Function body remains the same
    this.state._notificationSystem.addNotification({
      title: (
        <span
          data-notify="icon"
          className={
            lvl === "success"
              ? "pe-7s-check"
              : lvl === "error"
              ? "pe-7s-attention"
              : "pe-7s-bell"
          }
        ></span>
      ),
      message: <div>{msg}</div>,
      level: lvl,
      position: position,
      autoDismiss: duration,
    });
  };

  loadingData() {
    if (this.state.loading) {
      return (
        <div style={{ textAlign: "center" }}>
          <Loading />
        </div>
      );
    } else {
      return (
        <div style={{ textAlign: "center" }}>
          <NoDataFound />
        </div>
      );
    }
  }

  handleGroupNameChange(e) {
    this.setState({
      name: e.target.value,
    });
  }

  handleGroupDescChange(e) {
    this.setState({
      lockGroupDescription: e.target.value,
    });
  }

  getVisibleRows() {
    if (!this.lockTable) return [];

    const allData = this.lockTable.props.data || [];
    const filteredData =
      typeof this.lockTable.getTableData === "function"
        ? this.lockTable.getTableData(true, true)
        : allData;

    const { page = 1, sizePerPage = 5 } = this.lockTable.state || {};

    const startIndex = (page - 1) * sizePerPage;
    const endIndex = startIndex + sizePerPage;

    const visibleRows = filteredData.slice(startIndex, endIndex);

    // console.log("Visible rows:", visibleRows);
    return visibleRows;
  }

  getLockModelName(type) {
    let lock = "Lock Model Unknown";
    if (type === 1) {
      lock = "Debossed Lock";
    } else if (type === 2) {
      lock = "TSA Travel Lock";
    } else if (type === 3) {
      lock = "Padlock with NFC and Bluetooth";
    } else if (type === 4) {
      lock = "IP45 Padlock";
    } else if (type === 10) {
      lock = "IP66 Padlock";
    } else if (type === 7 || type === 8 || type === 9) {
      lock = "Lock Out Tag Out";
    } else if (type === 11) {
      lock = "Anti-Cut Padlock";
    } else if (type === 12) {
      lock = "Heavy Duty Padlock";
    } else if (type === 13) {
      lock = "IP66 LOTO";
    }
    // IP45 Padlock

    return lock;
  }

  convertTimeStamp(createdTime) {
    if (localizationStrings.getLanguage() === "ja") {
      // var japanDate = new Intl.DateTimeFormat("ja-JP", { era: "long" }).format(
      //   createdTime
      // );
      // var japanTime = new Intl.DateTimeFormat("ja-JP", {
      //   hour: "2-digit",
      //   minute: "2-digit"
      // }).format(createdTime);
      // return japanDate + japanTime;
      var japanDate =
        new Intl.DateTimeFormat("ja-JP", {
          year: "numeric",
        }).format(createdTime) +
        new Intl.DateTimeFormat("ja-JP", {
          month: "numeric",
        }).format(createdTime) +
        new Intl.DateTimeFormat("ja-JP", {
          day: "numeric",
        }).format(createdTime);
      var japanTime = new Intl.DateTimeFormat("ja-JP", {
        hourCycle: "h12",
        hour: "numeric",
        minute: "2-digit",
      }).format(createdTime);
      return japanDate + " " + japanTime;
    } else {
      // return new Intl.DateTimeFormat("en-US", {
      //   year: "numeric",
      //   month: "long",
      //   day: "numeric",
      //   hour: "numeric",
      //   minute: "2-digit"
      //   // second: "2-digit"
      // }).format(createdTime);
      return <TimeStamp time={createdTime / 1000} format="full" />;
    }
  }

  renderGroupProfile(cell, row) {
    return <LockGroupProfile cellValue={cell} rowValue={row} />;
  }

  renderLockDetailsBtn(cell, row) {
    return <LockGroupLocksButton cellValue={cell} rowValue={row} />;
  }

  renderGroupDetailsBtn(cell, row) {
    return (
      <LockGroupDetailsButton
        cellValue={cell}
        rowValue={row}
        dataCallBack={this.retrieveChanges}
      />
    );
  }

  async onAfterDeleteRow(rowKeys) {
    try {
      const snapshot = await fire
        .database()
        .ref("lockGroupManagement")
        .child(this.state.superAdminID)
        .child(auth.currentUser.uid)
        .once("value");

      const childKeys = snapshot.val() ? Object.keys(snapshot.val()) : [];

      const rowKeysString = rowKeys.map((key) => key.toString());

      const filteredChildKeys = [];
      const newrowkeys = [];
      for (let i = 0; i < rowKeysString.length; i++) {
        const key = rowKeysString[i];
        if (childKeys[key]) {
          newrowkeys.push(childKeys[key]);
        }
      }

      // Log the filtered child IDs
      // console.log("Filtered Child IDs:", filteredChildKeys);

      for (let i = 0; i < newrowkeys.length; i++) {
        await fire
          .database()
          .ref("lockGroupManagement")
          .child(this.state.superAdminID)
          .child(auth.currentUser.uid)
          .child(newrowkeys[i])
          .child("locks")
          .once("value")
          .then((snapshot) => {
            if (snapshot.exists()) {
              fire
                .database()
                .ref("lockGroupManagement")
                .child(this.state.superAdminID)
                .child(auth.currentUser.uid)
                .child(newrowkeys[i])
                .remove();
            } else {
              this.Disable();
            }
          });
      }

      await this.retrieveGroupDetails();
      this.showNotification(
        localizationStrings.deleteSuccessAlert,
        "success",
        "tc",
        5,
      );
    } catch (error) {
      console.error("Error deleting group:", error);
      this.showNotification(
        localizationStrings.deleteFailAlert,
        "error",
        "tc",
        5,
      );
    }
  }

  createCustomSearchFieldForm() {
    return (
      <SearchField
        // style={{ color: "blue" }}
        className="formSearchBar"
        // id="retractSearch"
        placeholder={localizationStrings.searchPlaceholder}
      />
    );
  }

  createCustomSelectAllButton() {
    return (
      <div className="searchSelectWrapper">
        <button
          className="createGroupBtn"
          onClick={() => {
            this.setState((prev) => {
              const notYetSelected = prev.locklistarray.filter(
                (lock) =>
                  !prev.selectedlockgroup.some(
                    (s) => s.ip45SerialNumber === lock.ip45SerialNumber,
                  ),
              );
              return {
                selectedlockgroup: [
                  ...prev.selectedlockgroup,
                  ...notYetSelected,
                ],
                locklistarray: [],
              };
            });
          }}
        >
          {localizationStrings.selectAllButton || "All"}
        </button>
        <SearchField
          className="formSearchBar"
          placeholder={localizationStrings.searchPlaceholder}
        />
      </div>
    );
  }

  createCustomSearchField() {
    return (
      <SearchField
        style={{ marginBottom: "7px" }}
        className="searchBar"
        // id="retractSearch"
        placeholder={localizationStrings.searchPlaceholder}
      />
    );
  }

  async retrieveGroupDetails() {
    if (this.state.superAdminID !== "") {
      await fire
        .database()
        .ref("lockGroupManagement")
        .child(this.state.superAdminID)
        .child(auth.currentUser.uid)
        .once("value")
        .then((snapshot) => {
          var tempArray = [];
          snapshot.forEach(function(childSnap) {
            var dataWithKey = {
              id: childSnap.key,
              ...childSnap.val(),
            };
            tempArray.push(dataWithKey);
          });

          this.setState({
            lockgrouparray: tempArray,
            loading: false,
          });
        });
    }

    return this.state.lockgrouparray;
  }

  onSubmit() {
    this.setState({ createGroupLoading: true });
    if (this.state.name != "" && this.state.selectedlockgroup.length > 1) {
      this.setState({
        lockGroupNameExist: false,
      });
      this.insertGroupData(this.state.superAdminID);
    } else if (
      this.state.name == "" &&
      this.state.selectedlockgroup.length < 2
    ) {
      this.showNotification(
        localizationStrings.emptyFormAlert,
        "error",
        "tc",
        5,
      );
      this.setState({ createGroupLoading: false });
    } else if (this.state.name == "") {
      this.showNotification(
        localizationStrings.enterNameAlert,
        "error",
        "tc",
        5,
      );
      this.setState({ createGroupLoading: false });
    } else if (this.state.selectedlockgroup.length < 2) {
      this.showNotification(
        localizationStrings.minimumLockAlert,
        "error",
        "tc",
        5,
      );
      this.setState({ createGroupLoading: false });
    } else {
      this.showNotification(
        localizationStrings.unableCreateAlert,
        "error",
        "tc",
        5,
      );
      this.setState({ createGroupLoading: false });
    }
  }

  async insertGroupData(superAdminID) {
    //! CHECK IF GROUP NAME ALREADY EXISTS
    await fire
      .database()
      .ref("lockGroupManagement")
      .child(superAdminID)
      .child(auth.currentUser.uid)
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          snapshot.forEach((name) => {
            if (this.state.name === name.val().name) {
              this.setState({
                lockGroupNameExist: true,
              });
            }
          });
        }
      });

    if (this.state.lockGroupNameExist === true) {
      this.showNotification(
        localizationStrings.nameExistsAlert,
        "error",
        "tc",
        5,
      );
      this.setState({ createGroupLoading: false });
    } else {
      const LockGroupId = fire
        .database()
        .ref()
        .push().key;
      const shareID = fire
        .database()
        .ref()
        .push().key;

      const lockGroupsRef = fire
        .database()
        .ref("lockGroupManagement")
        .child(superAdminID)
        .child(auth.currentUser.uid)
        .child(LockGroupId);

      const lockGroupData = {
        createdOn: Date.now(),
        desc: this.state.lockGroupDescription,
        locks: {},
        name: this.state.name,
        sharedInstances: {},
      };
      // lockGroupData.sharedInstances[shareID] = {
      //   allowAccess: false,
      //   recipientname: "test",
      //   reciepientType: "GROUP",
      //   reciepientUID: "name",
      //   shareStartTime: 0,
      //   shareEndTime: 0,
      //   sharePermiissionType: 0,
      //   sharingMode: "NORMAL",
      // };

      this.state.selectedlockgroup.forEach((selectedlockgroup) => {
        lockGroupData.locks[selectedlockgroup.id] =
          selectedlockgroup.ip45SerialNumber;
      });

      // window.location.reload();
      await lockGroupsRef.set(lockGroupData);
      await this.retrieveGroupDetails();
      this.handleCreateGroupPopupClose();

      this.showNotification(
        localizationStrings.createSuccessAlert,
        "success",
        "tc",
        5,
      );
      this.setState({ createGroupLoading: false });
    }
  }
  catch(error) {
    console.error("Error creating lockgroup:", error);
    this.showNotification(
      localizationStrings.createFailAlert,
      "error",
      "tc",
      5,
    );
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    //! FOR LANGUAGE SETTING
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    const customTotal = (from, to, size) => (
      <span
        className="react-bootstrap-table-pagination-total"
        style={{ float: "right" }}
      >
        {localizationStrings.resultTitle1}
        {from}
        {localizationStrings.resultTitle2}
        {to}
        {localizationStrings.resultTitle3}
        {size}
        {localizationStrings.resultTitle4}
      </span>
    );

    const selectRow = {
      bgColor: "#eeeeee",
      mode: "checkbox",
      selected: this.state.selectedLockGroups,
      onSelect: (row, isSelected) => {
        const { selectedLockGroups } = this.state;

        const updatedSelectedRows = isSelected
          ? [...selectedLockGroups, row.index]
          : selectedLockGroups.filter((index) => index !== row.index);

        this.setState({ selectedLockGroups: updatedSelectedRows });
      },
      onSelectAll: (isSelected) => {
        const updatedSelectedRows = isSelected
          ? indexedLockGroupArray.map((row) => row.index)
          : [];

        this.setState({ selectedLockGroups: updatedSelectedRows });
      },
    };

    const options = {
      insertBtn: this.createCustomInsertButton,
      searchField: this.createCustomSearchField,
      deleteBtn: this.createCustomDeleteButton,
      handleConfirmDeleteRow: (next, dropRowKeys) => {
        const selectedRows = indexedLockGroupArray.filter((row) =>
          dropRowKeys.includes(row.index),
        );
        confirmRemove(next, dropRowKeys, selectedRows);
      },
      afterDeleteRow: this.onAfterDeleteRow,

      page: 1, // which page you want to show as default
      sizePerPageList: [
        {
          text: "10",
          value: 10,
        },
        {
          text: "100",
          value: 100,
        },
        {
          text: "All",
          value: this.state.lockgrouparray.length,
        },
      ], // you can change the dropdown list for size per page
      sizePerPage: 10, // which size per page you want to locate as default
      pageStartIndex: 1, // where to start counting the pages
      paginationSize: 3, // the pagination bar size.
      prePage: "<", // Previous page button text
      nextPage: ">", // Next page button text
      firstPage: "<<", // First page button text
      lastPage: ">>", // Last page button text
      paginationShowsTotal: customTotal,
      noDataText: this.loadingData(),
    };

    const columnHover = (cell, row, enumObject, rowIndex) => {
      return cell;
    };
    const indexedLockGroupArray = this.state.lockgrouparray.map(
      (item, index) => {
        return { ...item, index: index }; // Add an 'index' property with the value of the current index
      },
    );
    return (
      <div className="header" style={{ margin: "auto" }}>
        <NotificationSystem ref="notificationSystem" style={style} />
        {/* <h4 style={{ marginTop: "40px" }}>
          {localizationStrings.descriptionTitle}
        </h4> */}
        <br />
        <BootstrapTable
          data={indexedLockGroupArray}
          bordered={false}
          pagination
          options={options}
          selectRow={selectRow}
          search
          insertRow
          deleteRow
        >
          <TableHeaderColumn
            dataField="index"
            isKey={true}
            hidden
          ></TableHeaderColumn>

          {/* <TableHeaderColumn dataField="groupName">
            Group Name
          </TableHeaderColumn> */}
          <TableHeaderColumn
            dataField="name"
            columnTitle={columnHover}
            // dataFormat={this.renderGroupProfile}
            dataSort
          >
            {localizationStrings.groupNameHeader}
          </TableHeaderColumn>
          <TableHeaderColumn width="30%" dataFormat={this.renderLockDetailsBtn}>
            {localizationStrings.groupLocksHeader}
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="createdOn"
            dataFormat={this.convertTimeStamp}
            // columnTitle={this.convertTimeStamp}
            dataSort
            tdStyle={{
              paddingLeft: "3%",
              whiteSpace: "normal",
            }}
            thStyle={{
              paddingLeft: "3%",
            }}
          >
            {localizationStrings.createdAtHeader}
          </TableHeaderColumn>
          <TableHeaderColumn
            width="13%"
            // dataField="groupName"
            dataFormat={this.renderGroupProfile}
            // dataSort
            tdStyle={{ textAlign: "center" }}
            thStyle={{ textAlign: "center" }}
          >
            {localizationStrings.groupInfoHeader}
          </TableHeaderColumn>
          <TableHeaderColumn
            width="13%"
            dataFormat={this.renderGroupDetailsBtn}
            tdStyle={{ textAlign: "center" }}
            thStyle={{ textAlign: "center" }}
          >
            {localizationStrings.groupEditHeader}
          </TableHeaderColumn>
        </BootstrapTable>

        {/* //! Popup for Create Group Button */}
        <Modal
          show={this.state.showPopup}
          onHide={this.handleCreateGroupPopupClose}
          dialogClassName="modal-70w"
        >
          <Modal.Header closeButton>
            <Modal.Title>{localizationStrings.createGroupBtn}</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: "30px 30px 40px 30px" }}>
            <form>
              <FormGroup>
                <ControlLabel style={{ fontSize: "1.2em" }}>
                  {localizationStrings.groupNameHeader}
                </ControlLabel>
                <FormControl
                  type="text"
                  placeholder={localizationStrings.groupNamePlaceholder}
                  onChange={this.handleGroupNameChange}
                ></FormControl>
              </FormGroup>
              <br />
              <FormGroup>
                <ControlLabel style={{ fontSize: "1.2em" }}>
                  {localizationStrings.groupDescriptionHeader}
                </ControlLabel>
                <FormControl
                  style={{ height: "100px" }}
                  componentClass="textarea"
                  placeholder={localizationStrings.groupDescriptionPlaceholder}
                  onChange={this.handleGroupDescChange}
                />
              </FormGroup>
              <br />
              <ControlLabel style={{ fontSize: "1.2em" }}>
                {localizationStrings.addMembersHeader}
              </ControlLabel>

              <div className="selectMembersTable">
                <BootstrapTable
                  ref={(table) => (this.lockTable = table)} // ref to access pagination info
                  data={this.state.locklistarray}
                  bordered={false}
                  pagination
                  search
                  options={{
                    sizePerPage: 5,
                    hideSizePerPage: true,
                    defaultSortOrder: "asc",
                    noDataText: localizationStrings.noDataTitle,
                    searchField: this.createCustomSearchFieldForm,
                  }}
                >
                  <TableHeaderColumn
                    dataField="Name"
                    tdStyle={{ textAlign: "center" }}
                    thStyle={{ textAlign: "center" }}
                  >
                    {localizationStrings.nameHeader}
                  </TableHeaderColumn>

                  <TableHeaderColumn
                    dataField="ip45SerialNumber"
                    isKey={true}
                    tdStyle={{ textAlign: "center" }}
                    thStyle={{ textAlign: "center" }}
                  >
                    {localizationStrings.emailHeader}
                  </TableHeaderColumn>

                  <TableHeaderColumn
                    dataField="Type"
                    dataFormat={this.getLockModelName}
                    tdStyle={{ textAlign: "center" }}
                    thStyle={{ textAlign: "center" }}
                  >
                    {localizationStrings.emailHeader1}
                  </TableHeaderColumn>

                  <TableHeaderColumn
                    dataFormat={this.renderSelectMember}
                    tdStyle={{ textAlign: "center" }}
                    thStyle={{ textAlign: "center" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        gap: "4px",
                        justifyContent: "center",
                      }}
                    >
                      {/* Select Visible */}
                      {/* <Button
                        bsStyle="info"
                        bsSize="small"
                        style={{
                          padding: "2px 6px",
                          fontSize: "10px",
                          whiteSpace: "nowrap",
                        }}
                        onClick={() => {
                          this.setState((prev) => {
                            const visibleRows = this.getVisibleRows();
                            const notYetSelected = visibleRows.filter(
                              (lock) =>
                                !prev.selectedlockgroup.some(
                                  (s) =>
                                    s.ip45SerialNumber === lock.ip45SerialNumber
                                )
                            );
                            return {
                              selectedlockgroup: [
                                ...prev.selectedlockgroup,
                                ...notYetSelected,
                              ],
                              locklistarray: prev.locklistarray.filter(
                                (lock) =>
                                  !notYetSelected.some(
                                    (n) =>
                                      n.ip45SerialNumber ===
                                      lock.ip45SerialNumber
                                  )
                              ),
                            };
                          });
                        }}
                      >
                        {localizationStrings.selectVisibleButton || "Visible"}
                      </Button> */}

                      {/* Select All */}
                      <Button
                        bsStyle="info"
                        bsSize="small"
                        style={{
                          padding: "2px 6px",
                          fontSize: "10px",
                          whiteSpace: "nowrap",
                        }}
                        onClick={() => {
                          this.setState((prev) => {
                            const notYetSelected = prev.locklistarray.filter(
                              (lock) =>
                                !prev.selectedlockgroup.some(
                                  (s) =>
                                    s.ip45SerialNumber ===
                                    lock.ip45SerialNumber,
                                ),
                            );
                            return {
                              selectedlockgroup: [
                                ...prev.selectedlockgroup,
                                ...notYetSelected,
                              ],
                              locklistarray: [],
                            };
                          });
                        }}
                      >
                        {localizationStrings.selectAllButton || "All"}
                      </Button>
                    </div>
                  </TableHeaderColumn>
                </BootstrapTable>

                {/* Selected Members Table */}
                <ControlLabel style={{ fontSize: "1.2em", marginTop: "15px" }}>
                  {localizationStrings.selectedMembersHeader}
                </ControlLabel>
                <BootstrapTable
                  data={this.state.selectedlockgroup}
                  bordered={false}
                  pagination
                  options={{
                    sizePerPage: 5,
                    hideSizePerPage: true,
                    noDataText: localizationStrings.noDataTitle,
                  }}
                >
                  <TableHeaderColumn
                    dataField="Name"
                    tdStyle={{ textAlign: "center" }}
                    thStyle={{ textAlign: "center" }}
                  >
                    {localizationStrings.nameHeader}
                  </TableHeaderColumn>

                  <TableHeaderColumn
                    dataField="ip45SerialNumber"
                    isKey={true}
                    tdStyle={{ textAlign: "center" }}
                    thStyle={{ textAlign: "center" }}
                  >
                    {localizationStrings.emailHeader}
                  </TableHeaderColumn>

                  <TableHeaderColumn
                    dataField="Type"
                    dataFormat={this.getLockModelName}
                    tdStyle={{ textAlign: "center" }}
                    thStyle={{ textAlign: "center" }}
                  >
                    {localizationStrings.emailHeader1}
                  </TableHeaderColumn>

                  <TableHeaderColumn
                    dataFormat={this.unselectMember}
                    tdStyle={{ textAlign: "center" }}
                    thStyle={{ textAlign: "center" }}
                  >
                    {/* Unselect All */}
                    <Button
                      bsStyle="danger"
                      bsSize="xsmall"
                      onClick={() => {
                        this.setState((prev) => ({
                          locklistarray: [
                            ...prev.locklistarray,
                            ...prev.selectedlockgroup,
                          ],
                          selectedlockgroup: [],
                        }));
                      }}
                    >
                      {localizationStrings.unselectAllButton || "Unselect All"}
                    </Button>
                  </TableHeaderColumn>
                </BootstrapTable>
              </div>

              {/* SELECT TABLE FOR GROUP */}
              {/* <div className="selectMembersTable">
                <BootstrapTable
                  ref={(table) => (this.lockTable = table)}
                  data={this.state.locklistarray}
                  bordered={false}
                  pagination
                  options={{
                    sizePerPage: 10,
                    hideSizePerPage: true,
                    defaultSortOrder: "asc", // default sort order
                    noDataText: localizationStrings.noDataTitle,
                    searchField: this.createCustomSearchFieldForm,
                  }}
                  search
                >
                  <TableHeaderColumn
                    dataField="Name"
                    tdStyle={{ textAlign: "center" }}
                    thStyle={{ textAlign: "center" }}
                  >
                    {localizationStrings.nameHeader}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="ip45SerialNumber"
                    isKey={true}
                    tdStyle={{ textAlign: "center" }}
                    thStyle={{ textAlign: "center" }}
                  >
                    {localizationStrings.emailHeader}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="Type"
                    dataFormat={this.getLockModelName}
                    tdStyle={{ textAlign: "center" }}
                    thStyle={{ textAlign: "center" }}
                  >
                    {localizationStrings.emailHeader1}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataFormat={this.renderSelectMember}
                    tdStyle={{ textAlign: "center" }}
                    thStyle={{ textAlign: "center" }}
                  >
                    <Button
                      bsStyle="primary"
                      bsSize="xsmall"
                      onClick={() => {
                        this.setState((prev) => {
                          const notYetSelected = prev.locklistarray.filter(
                            (lock) =>
                              !prev.selectedlockgroup.some(
                                (s) =>
                                  s.ip45SerialNumber === lock.ip45SerialNumber
                              )
                          );

                          return {
                            selectedlockgroup: [
                              ...prev.selectedlockgroup,
                              ...notYetSelected,
                            ],
                            locklistarray: prev.locklistarray
                              .filter(
                                (lock) =>
                                  prev.selectedlockgroup.some(
                                    (s) =>
                                      s.ip45SerialNumber ===
                                      lock.ip45SerialNumber
                                  ) === false
                              )
                              .filter(
                                (lock) =>
                                  !notYetSelected.some(
                                    (n) =>
                                      n.ip45SerialNumber ===
                                      lock.ip45SerialNumber
                                  )
                              ),
                          };
                        });
                      }}
                    >
                      {localizationStrings.selectAllButton || "Select All"}
                    </Button>
                  </TableHeaderColumn>
                </BootstrapTable>
                <ControlLabel style={{ fontSize: "1.2em" }}>
                  {localizationStrings.selectedMembersHeader}
                </ControlLabel>
                <BootstrapTable
                  data={this.state.selectedlockgroup}
                  bordered={false}
                  pagination
                  options={{
                    sizePerPage: 5,
                    hideSizePerPage: true,
                    noDataText: localizationStrings.noDataTitle,
                  }}
                >
                  <TableHeaderColumn
                    dataField="Name"
                    tdStyle={{ textAlign: "center" }}
                    thStyle={{ textAlign: "center" }}
                  >
                    {localizationStrings.nameHeader}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="ip45SerialNumber"
                    isKey={true}
                    tdStyle={{ textAlign: "center" }}
                    thStyle={{ textAlign: "center" }}
                  >
                    {localizationStrings.emailHeader}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="Type"
                    dataFormat={this.getLockModelName}
                    tdStyle={{ textAlign: "center" }}
                    thStyle={{ textAlign: "center" }}
                  >
                    {localizationStrings.emailHeader1}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataFormat={this.unselectMember}
                    tdStyle={{ textAlign: "center" }}
                    thStyle={{ textAlign: "center" }}
                  ></TableHeaderColumn>
                </BootstrapTable>
              </div> */}

              <FormGroup style={{ display: "flex" }}>
                <Button
                  style={{ marginRight: "10px" }}
                  onClick={this.onSubmit}
                  disabled={this.state.createGroupLoading}
                >
                  {this.state.createGroupLoading
                    ? localizationStrings.loading
                    : localizationStrings.createTitle}
                </Button>
                <Button
                  style={{ marginLeft: "10px" }}
                  onClick={this.handleCreateGroupPopupClose}
                >
                  {localizationStrings.cancelTitle}
                </Button>
              </FormGroup>
            </form>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

const authCondition = (authUser) => !!authUser;
export default withAuthorization(authCondition)(LockGroupManagement);
